angular.module('app').controller('ownerLegalController',
  ['$scope', function (scope) {

  }]);
